import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import Image from 'next/image';
import ArrowBack from '@material-ui/icons/ArrowBackIos';
import ArrowForward from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles(() => ({
    arrowButton: {
        position: 'absolute',
        width: 40,
        height: 40,
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20,
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
    },
}));

const Slideshow = (props) => {
    const classes = useStyles();
    return (
        <div>
            <Fade
                indicators={false}
                autoplay={true}
                transitionDuration={1200}
                arrows={false}
                easing="ease"
                style={{ marginTop: 30, backgroundColor: 'black' }}
                prevArrow={
                    <Box
                        style={{
                            position: 'absolute',
                            left: 30,
                        }}
                        className={classes.arrowButton}
                    >
                        <ArrowBack style={{ color: '#FFF', marginLeft: 8 }} />
                    </Box>
                }
                nextArrow={
                    <Box
                        style={{
                            position: 'absolute',
                            right: 30,
                        }}
                        className={classes.arrowButton}
                    >
                        <ArrowForward style={{ color: '#FFF', marginLeft: 4 }} />
                    </Box>
                }
            >
                {props.images.map((item, ind) => {
                    return (
                        <div
                            key={ind}
                            className="each-slide"
                            style={{
                                width: '100%',
                                height: 'auto',
                                minHeight: props.height,
                            }}
                        >
                            <a target="_blank" href={item.link} rel="noreferrer">
                                <Image
                                    alt=""
                                    quality={60}
                                    layout="fill"
                                    objectFit="cover"
                                    loader={() => item.image}
                                    src={item.image}
                                />
                                <div
                                    style={{
                                        color: '#FFFFFF',
                                        textAlign: 'right',
                                        position: 'absolute',
                                        padding: 12,
                                        marginTop: 20,
                                        bottom: 20,
                                        right: 40,
                                    }}
                                >
                                    {item.name}
                                </div>
                            </a>
                        </div>
                    );
                })}
            </Fade>
        </div>
    );
};

Slideshow.defaultProps = {
    images: ['/slider/1.jpeg', '/slider/2.jpeg', '/slider/2.jpeg'],
};

export default Slideshow;
